import {
  acaoProjetoApuracao,
  buscarProjetoApuracao,
  listarProjetosApuracao,
  projetosApuracaoPorCliente,
  salvarProjetoApuracao,
} from "./api-relatorios.service";

/**
 * TXM-558 — Projetos de Apuração. Nenhuma função lança: o erro vira
 * `{ sucesso: false, mensagem, codigo?, status? }`, com a mensagem do servidor quando houver.
 */

const ACOES_VALIDAS = [
  "atualizar-valores",
  "enviar",
  "liberar",
  "cancelar",
  "aprovar",
  "reenviar-creditos",
];

function erroDaApi(error, mensagemPadrao) {
  const data = error?.response?.data;
  const resultado = {
    sucesso: false,
    mensagem: data?.mensagem || error?.message || mensagemPadrao,
  };
  if (data?.codigo) resultado.codigo = data.codigo;
  if (error?.response?.status) resultado.status = error.response.status;
  return resultado;
}

/**
 * Cria um projeto a partir do resultado filtrado, ou sobrescreve um Em Prévia.
 * @param {{ idRelatorioApuracao: number, filtros: object, chaves: Array<{ chaveConta: string, competencia: string }>, sobrescreverIdProjeto?: number|null }} params
 */
export async function salvarProjeto({ idRelatorioApuracao, filtros, chaves, sobrescreverIdProjeto = null }) {
  try {
    return await salvarProjetoApuracao({
      idRelatorioApuracao,
      filtros,
      chaves,
      sobrescreverIdProjeto,
    });
  } catch (error) {
    return erroDaApi(error, "Erro ao salvar o projeto.");
  }
}

/** @param {object} params página e filtros da lista */
export async function listarProjetos(params) {
  try {
    return await listarProjetosApuracao(params);
  } catch (error) {
    return erroDaApi(error, "Erro ao listar os projetos.");
  }
}

/** @param {string|number} id */
export async function buscarProjeto(id) {
  try {
    return await buscarProjetoApuracao(id);
  } catch (error) {
    return erroDaApi(error, "Erro ao consultar o projeto.");
  }
}

/** @param {{ cnpj: string, tipo: string }} params */
export async function listarProjetosDoCliente({ cnpj, tipo } = {}) {
  if (!cnpj || !tipo) {
    return { sucesso: false, mensagem: "CNPJ e tipo são obrigatórios." };
  }
  try {
    return await projetosApuracaoPorCliente({ cnpj, tipo });
  } catch (error) {
    return erroDaApi(error, "Erro ao consultar os projetos do cliente.");
  }
}

/**
 * @param {string|number} id
 * @param {'atualizar-valores'|'enviar'|'liberar'|'cancelar'|'aprovar'|'reenviar-creditos'} acao
 */
export async function executarAcaoProjeto(id, acao) {
  if (!ACOES_VALIDAS.includes(acao)) {
    return { sucesso: false, mensagem: "Ação inválida." };
  }
  try {
    return await acaoProjetoApuracao(id, acao);
  } catch (error) {
    return erroDaApi(error, "Erro ao executar a ação no projeto.");
  }
}
